'use strict';

var _ = require('lodash');
var moment = require('moment');
var ChartFBCUsageDataService = function ChartFBCUsageDataService(commonFaresChartComponentsService, dataRetrieverService, dataRetrieverConstantsService, svgPatternService, momentService, classIndicesService, $q) {
  function getCurrentMonth() {
    return momentService.now(momentService.FIELD.FARES_USAGE_DATE).month();
  }
  function getCurrentYear() {
    return momentService.now(momentService.FIELD.FARES_USAGE_DATE).year();
  }
  var legend = commonFaresChartComponentsService.getInitialLegend();
  var monthLegend = '';
  function adaptDataToChart(orginalData) {
    var data = _.cloneDeep(orginalData);
    _.forEach(data, function (d) {
      if (d.isGap) {
        return;
      }

      //prepare data for displaying in bar chart
      for (var j = 1; j < d.data.length; j++) {
        d.data[j] += d.data[j - 1];
      }

      //revert data, because smaller bar must be render on bigger
      d.data.reverse();
      d.css.reverse();
      d.patternBarY = 0;
    });
    return data;
  }
  function createDataForChart(originalData, legend, className) {
    var data = originalData;
    data = _.sortBy(data, 'code');
    var patternUrl = svgPatternService.getPatternUrl('inactive-bar');
    _.forEach(data, function (d) {
      d.stackLabel = d.code;
      d.patternBarX = 0;
      d.fill = patternUrl;
      if (d.isGap) {
        return;
      }
      var dataPreparedToDisplay = [];
      var dataPreparedForTooltip = [];
      var barCss = [];

      //arrange data in appropriate order
      //Previous month must be on top
      //We starts with current month eventually it will be on the bottom
      for (var i = 0; i < 12; i++) {
        var index = (getCurrentMonth() + i) % 12;
        dataPreparedToDisplay.push(d.data[index]);
        barCss.push(legend[index].barCss);
        if (d.data[index] && legend[index].label) {
          dataPreparedForTooltip.push({
            value: d.data[index],
            month: legend[index].label
          });
        }
      }

      //store prepare data
      d.tooltipData = _.reverse(dataPreparedForTooltip);
      d.data = dataPreparedToDisplay;
      d.css = barCss;
    });
    var adaptedData = adaptDataToChart(data);
    return {
      data: adaptedData,
      className: className
    };
  }
  function setActualMonth(monthNumber) {
    if (monthNumber >= getCurrentMonth()) {
      return monthNumber - 12;
    } else {
      return monthNumber;
    }
  }
  function groupMonths(months) {
    var sortedMonths = months.sort(function (a, b) {
      return setActualMonth(a) - setActualMonth(b);
    });
    var current = months[0];
    var group = [current];
    var groupedMonths = [group];
    for (var i = 1; i < sortedMonths.length; i++) {
      if (sortedMonths[i] === current + 1 || sortedMonths[i] === 0 && current === 11) {
        current = sortedMonths[i];
        group.push(current);
      } else {
        current = sortedMonths[i];
        group = [current];
        groupedMonths.push(group);
      }
    }
    return groupedMonths;
  }
  function createMonthLegend(groupedMonths) {
    var currentMonth = getCurrentMonth();
    var currentYear = getCurrentYear();
    var monthsNames = moment.monthsShort();
    var res = [];
    for (var i = 0; i < groupedMonths.length; i++) {
      var group = groupedMonths[i];
      var str = '';
      if (group.length === 1) {
        str = monthsNames[group[0]];
        if (group[0] < currentMonth && i === groupedMonths.length - 1) {
          str += ' ' + currentYear;
        } else if (group[0] >= currentMonth && (i === groupedMonths.length - 1 || groupedMonths[i + 1][0] < currentMonth)) {
          str += ' ' + (currentYear - 1);
        }
      } else {
        if (group[0] > group[group.length - 1]) {
          str = monthsNames[group[0]] + ' ' + (currentYear - 1) + '-' + monthsNames[group[group.length - 1]] + ' ' + currentYear;
        } else if (group[0] < currentMonth) {
          str = monthsNames[group[0]] + '-' + monthsNames[group[group.length - 1]];
          if (i === groupedMonths.length - 1) {
            str += ' ' + currentYear;
          }
        } else {
          str = monthsNames[group[0]] + '-' + monthsNames[group[group.length - 1]];
          if (i === groupedMonths.length - 1 || groupedMonths[i + 1][0] < currentMonth) {
            str += ' ' + (currentYear - 1);
          }
        }
      }
      res.push(str);
    }
    return res.join(', ');
  }
  function groupData(rawData, showInactive) {
    var dateRange = momentService.getFaresDateRange();
    return _.chain(rawData).groupBy('fareBasisCode').transform(function (result, value, key) {
      var data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      _.forEach(value, function (i) {
        if (momentService.isEventTimeWithinRange(i.eventTimeStamp, dateRange)) {
          data[i.month - 1] = i.traffic;
        }
      });
      result.push({
        clazz: value[0].className,
        code: key,
        data: data,
        isInactive: value[0].isInactive
      });
    }, []).filter(function (item) {
      return showInactive || !item.isInactive;
    }).groupBy('clazz').value();
  }
  function prepareChartData(rawData, classes, market, showInactive, marketTagKey) {
    var groupedData = groupData(rawData, showInactive);
    var classesIndices = classIndicesService.prepareClassIndices(marketTagKey);
    return _.chain(classes).transform(function (result, className) {
      if (groupedData[className]) {
        var classData = createDataForChart(groupedData[className], legend, className);
        setInactiveBars(classData.data);
        result.push(classData);
      } else {
        result.push({
          data: [],
          className: className
        });
      }
    }, []).sortBy(function (item) {
      return classesIndices[item.className];
    }).value();
  }
  function setInactiveData(data) {
    var revenueAccountingData = data[0];
    var futureFares = data[1];
    var futureFaresGroupedByCode = _.groupBy(futureFares, 'fbc');
    function checkInactive(revenueAccounting, code) {
      var futureFareByCode = futureFaresGroupedByCode[code];
      var isInactive = true;
      if (!_.isUndefined(futureFareByCode)) {
        var transformedRevenueAccounting = {
          destination: revenueAccounting[0].marketDestination,
          origin: revenueAccounting[0].marketOrigin
        };
        isInactive = !_.some(futureFareByCode, transformedRevenueAccounting);
      }
      return isInactive;
    }
    function setInactive(revenueAccountingData) {
      _.chain(revenueAccountingData).groupBy('fareBasisCode').transform(function (result, revenueAccounting, fareBasisCode) {
        var isInactive = checkInactive(revenueAccounting, fareBasisCode);
        _.forEach(revenueAccounting, function (i) {
          i.isInactive = isInactive;
        });
      }, []).value();
    }
    setInactive(revenueAccountingData);
    return revenueAccountingData;
  }
  function getData() {
    var revenueAccountingDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.FARES_CHART_MODE);
    var futureFaresDataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.FARES_SCREEN, dataRetrieverConstantsService.FARES_MODE);
    return $q.all([revenueAccountingDataRetriever.localSortApplied().retrieveComponentData('fares-fbc-usage-chart'), futureFaresDataRetriever.localSortApplied().retrieveComponentData('fares-fbc-usage-chart')]).then(setInactiveData);
  }
  function adjustMonthIndex(monthsArray) {
    return _.map(monthsArray, function (month) {
      return month - 1;
    });
  }
  function getLegend(monthsArray) {
    var adjustedMonths = adjustMonthIndex(monthsArray);
    var groupedMonths = groupMonths(adjustedMonths);
    monthLegend = createMonthLegend(groupedMonths);
    return monthLegend;
  }
  function setInactiveBars(preparedData) {
    _.forEach(preparedData, function (codeData) {
      if (codeData.isInactive) {
        codeData.patternBarY = codeData.data[0];
      }
    });
    return preparedData;
  }
  return {
    getData: getData,
    prepareChartData: prepareChartData,
    getLegend: getLegend
  };
};
ChartFBCUsageDataService.$inject = ['CommonFaresChartComponentsService', 'DataRetrieverService', 'DataRetrieverConstantsService', 'SvgPatternService', 'MomentService', 'ClassIndicesService', '$q'];
module.exports = ChartFBCUsageDataService;